import { useGetUserSession } from './useGetUserSession';


type UseGetSubClientIdReturn = {
    subClientId: string | undefined;
    roleType: string | undefined;
    isSubClient: boolean;
};

export function useGetSubClientId(
): UseGetSubClientIdReturn {
    const { session } = useGetUserSession();

    return {
        subClientId: session?.subClientId,
        roleType: session?.roleType,
        isSubClient: session?.roleType === 'subClient' && !!session?.subClientId,
    };
}